<template>
  <section class="hero is-small is-primary top-section gov-header">
    <div class="hero-body">
      <div class="columns is-align-items-center top-piece">
        <div class="column">
          <div class="container has-text-right has-text-centered-mobile">
            <p @click="$route.name === 'Index' || $router.push({name: 'Index'})" class="title notranslate">
              Kolibri
            </p>
            <p @click="$route.name === 'Index' || $router.push({name: 'Index'})" class="subtitle">
              Governance
            </p>
          </div>
        </div>
        <div class="column">
          <div @click="$route.name === 'Index' || $router.push({name: 'Index'})" class="token-holder is-inline-block hover-zoom">
            <img class="kolibri-token" src="../assets/kolibri-token.svg">
          </div>
        </div>
      </div>
    </div>
    <div v-if="$store.isTestnet" class="columns is-centered top-piece">
      <div class="column is-three-fifths-desktop">
        <div class="notification is-warning">
          <b>Please Note!</b> This is a <b>testnet DAO</b>, currently running on the <b style="text-transform: capitalize">{{ $store.network }}</b> network.
        </div>
      </div>
    </div>
    <div v-if="$store.isSandbox" class="columns is-centered top-piece">
      <div class="column is-three-fifths-desktop">
        <div class="notification is-warning">
          <b>Please Note!</b> This is a <b>sandbox DAO</b>, do not expect changes to persist and data may be reverted at any time!
        </div>
      </div>
    </div>
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: 'GovHeader',
  props: [],
  mounted(){

  },
  components: {

  },
  data(){
    return {
    }
  },
  methods: {

  }
}
</script>

<style type="text/scss" lang="scss">
@import '../assets/sass/globals';
.gov-header{
  p.title, p.subtitle{
    cursor: pointer;
    &.not-linked{
      cursor: auto;
    }
  }
  .token-holder{
    &:hover{
      .kolibri-token{
        box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
        transform: rotateY(-180deg);
      }
    }
    &:active{
      transition: box-shadow 250ms linear;
      .kolibri-token{
        box-shadow: none;
      }
    }
    .kolibri-token{
      cursor: pointer;
      border-radius: 100rem;
      max-height: 10rem;
      transform: rotateY(0deg);
      transition: transform 1s ease-in-out, box-shadow 1s linear;
      box-shadow: none;
    }
  }
  .hover-zoom{
    transition: transform .5s ease;
    &:hover{
      transform: scale(1.1);
    }
  }
}
</style>
